import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import './styles/login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [isResetting, setIsResetting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setResetMessage('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
      window.location.href = '/admin';
    } catch (error) {
      setError('Login fejlede: ' + error.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Indtast venligst din email-adresse');
      return;
    }
    
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMessage('Email med nulstilling af kodeord er sendt. Tjek din indbakke.');
      setError('');
      setIsResetting(false);
    } catch (error) {
      setError('Fejl ved nulstilling af kodeord: ' + error.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Login</h1>
        {!isResetting ? (
          <>
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Email:</label>
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Kodeord:</label>
                <input 
                  type="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              {error && <p className="error-message">{error}</p>}
              {resetMessage && <p className="success-message">{resetMessage}</p>}
              <button type="submit" className="submit-btn">Login</button>
            </form>
            <button 
              onClick={() => setIsResetting(true)}
              className="forgot-password-btn"
            >
              Glemt kodeord?
            </button>
          </>
        ) : (
          <>
            <form onSubmit={handleResetPassword}>
              <div className="form-group">
                <label>Email:</label>
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {error && <p className="error-message">{error}</p>}
              {resetMessage && <p className="success-message">{resetMessage}</p>}
              <button type="submit" className="submit-btn">Nulstil kodeord</button>
            </form>
            <button 
              onClick={() => setIsResetting(false)}
              className="back-to-login-btn"
            >
              Tilbage til login
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;
